<div class="fab-container" [hidden]="!show">
  <div class="fab shadow">
    <div class="fab-content">
      <span class="fa fa-pen-to-square"></span>
    </div>
  </div>
  <div class="sub-button shadow" *ngFor="let action of actions" (click)="action.fn()" [title]="action.tooltip">
    <span [class]="'fa '+action.icon"></span>
  </div>
</div>